import { createRouter, createWebHistory } from "vue-router";
import MainLayout from "../layouts/MainLayout.vue";
import Dashboard from "../views/Dashboard.vue";
import Users from "../views/Users.vue";
import Login from "../views/Auth/Login.vue";
import TestComponent from "@/components/TestComponent.vue";
import FullTestComponent from "@/components/FullTestComponent.vue";
import ViewAssets from "@/views/ViewAssets.vue";
import ListTest from "@/components/ListTest.vue";
import UserList from "@/views/User/UserList.vue";
import VendorList from "@/views/Vendor/VendorList.vue";
import CreateVendor from "@/views/Vendor/CreateVendor.vue";
import VendorProfile from "@/views/Vendor/VendorProfile.vue";
import TeamList from "@/views/Team/TeamList.vue";
import CategoryList from "@/views/Asset/Category/CategoryList.vue";
import AssetList from "@/views/Asset/AssetList.vue";
import MaterialList from "@/views/Materials/MaterialList.vue";
import LocationList from "@/views/Location/LocationList.vue";
import CreateLocation from "@/views/Location/CreateLocation.vue";

import Builder from '@/views/Template/Builder.vue'
import TemplateList from '@/views/Template/TemplateList.vue'
import RequestList from '@/views/WO/Request/RequestList.vue'
// import TemplateBuilder from '@/views/Template/Builder.vue'
import UserProfile from "@/views/User/UserProfile.vue";
import ImportUser from "@/views/User/ImportUser.vue";
import OrderList from "@/views/PurchaseOrders/OrdersList.vue";
import CreateOrder from "@/views/PurchaseOrders/CreateOrder.vue";
import OrderProfile from "@/views/PurchaseOrders/OrderProfile.vue";
import PublicOrderView from "@/views/PurchaseOrders/PublicOrderView.vue";

import CreateCategory from "@/views/Categories/CreateCategory.vue";
import CategoryIndex from "@/views/Categories/Index.vue";
import AssetImport from "@/views/Asset/Import.vue";
import MaterialImport from "@/views/Materials/Import.vue";
import MaterialProfile from "@/views/Materials/MaterialProfile.vue";
import AssetProfile from "@/views/Asset/AssetProfile.vue";
import LibraryList from "@/views/Library/LibraryList.vue";
import TeamProfile from '@/views/Team/TeamProfile.vue';
import NotificationList from '@/views/Notifications/NotificationList.vue';
import CompanySelect from "@/views/Auth/CompanySelect.vue";
import MyProfile from "@/views/Auth/MyProfile.vue";
const routes = [
  {
    path: "/builder",
    name: "Builder",
    component: Builder,
  },
  {
    path: "/vendor/order/:external_id",
    name: "PublicOrderView",
    component: PublicOrderView,
  },
  {
    path: "/",
    component: MainLayout,
    children: [
      {
        path: "",
        redirect: "/dashboard",
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
      },
      {
        path: "users",
        name: "Users",
        component: Users,
      },
      {
        path: "listtest",
        name: "listtest",
        component: ListTest,
      },
      {
        path: "ViewAssets",
        name: "ViewAssets",
        component: ViewAssets,
      },
      {
        path: "user",
        children: [
          {
            path: "list",
            name: "UserList",
            component: UserList,
          },
          {
            path: "/:external_id/profile",
            name: "user.profile",
            component: UserProfile,
          },
          {
            path: "import",
            name: "user.import",
            component: ImportUser,
          },
          {
            path: "myProfile",
            name: "myProfile",
            component: MyProfile,
          }
        ],
      },
      {
        path: "vendor",
        children: [
          {
            path: "list",
            name: "VendorList",
            component: VendorList,
          },
          {
            path: "create",
            name: "CreateVendor",
            component: CreateVendor,
          },
          {
            path: ":external_id/profile",
            name: "VendorProfile",
            component: VendorProfile,
          },
        ],
      },
      {
        path: "team",
        children: [
          {
            path: "list",
            name: "TeamList",
            component: TeamList,
          },
          {
            path: ':external_id',
            name: 'TeamProfile',
            component: TeamProfile,
          }

        ],
      },
      {
        path: "asset/category",
        children: [
          {
            path: "list",
            name: "CategoryList",
            component: CategoryList,
          },
        ],
      },
      {
        path: "asset/",
        children: [
       {
          path: 'profile/:external_id',
          name: 'AssetProfile',
          component: AssetProfile,
        },
                  {
            path: "list",
            name: "AssetList",
            component: AssetList,
          },
          {
            path: "import",
            name: "AssetImport",
            component: AssetImport,
          },
        ],
      },
      {
      path:'notification/',
      children:[
        {
          path:'list',
          name:'NotificationsList',
          component: NotificationList,
        },
      ]
      },
   
      {
        path: 'template',
        children: [
          {
            path: 'list',
            name: 'TemplateList',
            component: TemplateList
          },
          {
            path: 'builder/:id',
            name: 'TemplateBuilder',
            component: Builder
          }
        ],
      },
       {
        path: 'wo/request',
        children: [
          {
            path: 'list',
            name: 'RequestList',
            component: RequestList
          },
          
        ],
      },
     
      
      {
        path: "materials",
        children: [
            {
              path: 'profile/:external_id',
              name: 'MaterialProfile',
              component: MaterialProfile,
            },
          {
            path: "list",
            name: "MaterialList",
            component: MaterialList,
          },
          {
            path: "import",
            name: "MaterialImport",
            component: MaterialImport,
          },
         
        ],
      },
      {
        path: "/material-categories",
        children: [
          {
            path: "list",
            name: "CategoryIndex",
            component: CategoryIndex,
          },
          {
            path: "create",
            name: "CreateCategory",
            component: CreateCategory,
          },
        ],
      },
      {
        path: "purchase-orders",
        children: [
          {
            path: "list",
            name: "OrderList",
            component: OrderList,
          },
          {
            path: "create",
            name: "CreateOrder",
            component: CreateOrder,
          },
          {
            path: ":external_id/profile",
            name: "OrderProfile",
            component: OrderProfile,
          },
        ],
      },
      {
        path: "location",
        children: [
          {
            path: "list",
            name: "LocationList",
            component: LocationList,
          },
          {
            path: "create",
            name: "CreateLocation",
            component: CreateLocation,
          },
        ],
      },
{
        path: "library",
        children: [
          {
            path: "list",
            name: "Library",
            component: LibraryList,
          },
        ],
      },
      // {
      //   path: 'users/list',
      //   name: 'UserList',
      //   component: ListUser
      // }
      // {
      //   path: 'users',
      //   component: ListTest,
      //   children: [
      //     {
      //       path: '',
      //       name: 'UserList',
      //       component: ListTest
      //     },
      //     {
      //       path: 'create',
      //       name: 'UserCreate',
      //       component: CreateUser
      //     }
      //   ]
      // },
    ],
  },

  {
    path: "/test",
    name: "Test",
    component: TestComponent,
  },

  {
    path: "/full-test",
    name: "FullTest",
    component: FullTestComponent,
  },

  {
    path: "/auth",
    children: [
      {
        path: "login",
        name: "Login",
        component: Login,
      },
       {
      path: '/select-company',
      name: 'CompanySelect',
      component: CompanySelect,
       meta: { layout: 'default' } 
    },
    ],
  },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
